import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=5230ee03"
import script from "./Loyalty.vue?vue&type=script&lang=js"
export * from "./Loyalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports